import {
  createBarDatasetConfig,
  createSkillSetChartOptions
} from '@utils/chartConfig'
import {
  BarElement,
  CategoryScale,
  ChartData,
  Chart as ChartJS,
  Legend,
  LinearScale,
  Title,
  Tooltip
} from 'chart.js'
import ChartDataLabels from 'chartjs-plugin-datalabels'
import { Bar } from 'react-chartjs-2'

import { Entities_Assessment_GoalsInfoSkillSet_Response } from '@suntex.fim/api-client'

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
  ChartDataLabels
)

const options = createSkillSetChartOptions(true)
const levelPoints: Record<number, number> = { 0: 0, 1: 0, 2: 2, 3: 4, 4: 5 }
/**
 * returns JSX for assessment skill set chart
 */
function SkillSetCharts({
  backgroundColor,
  level = 0,
  chartData = {}
}: {
  backgroundColor: string
  level: number
  chartData: Entities_Assessment_GoalsInfoSkillSet_Response['ss']
}) {
  const SKILL_SET_COUNT = 3
  const dataSetKeys = Object.keys(chartData).splice(
    levelPoints[level],
    SKILL_SET_COUNT
  )
  const labels = dataSetKeys.map((key) => `Skill Set ${key} (Games 1, 2 & 3)`)
  const data: ChartData<'bar', number[], string> = {
    labels,
    datasets: dataSetKeys.map((key, i) => ({
      label: key,
      data: dataSetKeys.map((dataKey) => chartData[dataKey][i + 1]),
      ...createBarDatasetConfig(backgroundColor)
    }))
  }
  return (
    <div className="bar-chart-data">
      <Bar options={options} data={data} />
    </div>
  )
}

export default SkillSetCharts
